import message from "ant-design-vue/lib/message";

function fetchOrder(successCallback, noOrderCallback, failedCallback) {
    var data = {};
    var url = '/mark'
    sessionStorage.setItem("review", false)

    //这里先不判断是否已经考核完，因为怀疑打标员不关浏览器造成sessionStorage的reviewFinish持续为true，造成后续不请求考核订单
    // if (!sessionStorage.getItem('reviewFinish')) {
        var roll = Math.round(Math.random()*40)
        console.log("------------roll--------------", roll)
        //roll会随机返回0-41的整数，随便确定1的命中概率大概是2.5%
        if (roll == 1) {
            url = '/mark-review-order'
            sessionStorage.setItem("review", true)
        }
    // }

    if (sessionStorage.getItem('role') == 28) {
        url = '/mark-test-order'
    }

    url = process.env.VUE_APP_API_SERVER + url

    console.log("fetchOrder", url)

    fetch(url, {
        method: 'POST', // or 'PUT'
        body: JSON.stringify(data), // data can be `string` or {object}!
        headers: new Headers({
            'Content-Type': 'application/json',
            'Access-Token': sessionStorage.getItem('accessToken')
        })
    }).then(res => res.json())
        .catch(error => {
            if (error.status == 401) {
                // Only call failedCallback when receive 401 error.
                sessionStorage.setItem("fetchError", true)
                failedCallback()
            } else {
                noOrderCallback()
                if (JSON.parse(sessionStorage.getItem('review'))) {
                    sessionStorage.setItem("reviewFinish", true)
                }
                console.log("fetchOrder error: ", error)
            }
        })
        .then(response => {
            if (Object.keys(response).length == 0) {
                noOrderCallback()
                if (JSON.parse(sessionStorage.getItem('review'))) {
                    sessionStorage.setItem("reviewFinish", true)
                }
                return
            }
            console.log("#### ", response)
            if (response.error == "invalid role") {
                sessionStorage.setItem("401", true)
                failedCallback()
            } else if(response.error == "resource not found") {
                noOrderCallback()
                if (JSON.parse(sessionStorage.getItem('review'))) {
                    sessionStorage.setItem("reviewFinish", true)
                }
                console.log("fetchOrder error noOrderCallback : ", response.error)
            }  else {
                if (Object.keys(response).length > 0 && typeof(response.error) == "undefined") {
                    var cupboardCommodities = []
                    var consumerCommodities = []
                    var videoUrl = ""
                    var orderId = -1
                    var consumerOrderId = -1
                    var stats = {}
                    var expiredAfter = 0
                    var priority = 0

                    orderId = response.OrderId
                    consumerOrderId = response.ConsumerOrderId
                    stats = response.Stats
                    expiredAfter = response.ExpiredAfter

                    var commodityDict = {}

                    var containerCommodities = []
                    for (var i = 0; i < response.Commodities.length; i++) {
                        containerCommodities.push({
                            id: response.Commodities[i].CommodityId,
                            name: response.Commodities[i].Name,
                            images: response.Commodities[i].Images,
                            packId: response.Commodities[i].PackId,
                            number: 0,
                            showThumbnail: false,
                            showThumbnailOffsetX: 0,
                            showThumbnailOffsetY: 0,
                            type: "cupboard"
                        })

                        commodityDict[response.Commodities[i].CommodityId] = response.Commodities[i]
                    }

                    var consumerCommodityIds = response.ConsumerOrderDetails.map((e) => e.CommodityId)

                    cupboardCommodities = containerCommodities.filter((e) => {
                        return !consumerCommodityIds.includes(e.id)
                    }).sort(function (a, b) {
                        return b.packId - a.packId
                    })

                    for (var i = 0; i < response.ConsumerOrderDetails.length; i++) {
                        consumerCommodities.push({
                            id: response.ConsumerOrderDetails[i].CommodityId,
                            name: commodityDict[response.ConsumerOrderDetails[i].CommodityId].Name,
                            images: commodityDict[response.ConsumerOrderDetails[i].CommodityId].Images,
                            number: 0,
                            showThumbnail: false,
                            showThumbnailOffsetY: 0,
                            type: "consumer",
                            amount: response.ConsumerOrderDetails[i].Amount
                        })
                    }

                    videoUrl = response.VideoUrl
                    priority = response.Priority
                    successCallback(orderId, consumerOrderId, stats, consumerCommodities, cupboardCommodities, videoUrl, expiredAfter, priority)
                } else {
                    console.log("fetchOrder response error: ", response.error)
                    noOrderCallback()
                    if (JSON.parse(sessionStorage.getItem('review'))) {
                        sessionStorage.setItem("reviewFinish", true)
                    }
                }
            }
        });
}

function fetchExceptionOptions(callback) {
    var url = process.env.VUE_APP_API_SERVER + '/abnormal'


    fetch(url, {
        method: 'GET', // or 'PUT'
        headers: new Headers({
            'Content-Type': 'application/json',
            'Access-Token': sessionStorage.getItem("accessToken")
        })
    }).then(res => res.json())
        .catch(error => {
            console.error('fetchExceptionOptions error:', error)
        })
        .then(response => {
            callback(response)
        });
}

function confirmOrder(orderId, commodityList, nextOrderCallback) {
    if (orderId == 0) {
        return
    }
    var orderDetails = []

    for (var id in commodityList) {
        orderDetails.push({
            CommodityId: parseInt(id),
            Amount: commodityList[id].number
        })
    }

    var url = "/mark/"
    if (JSON.parse(sessionStorage.getItem('review'))) {
        url = '/mark-review-order/'
    }

    if (sessionStorage.getItem('role') == 28) {
        url = '/mark-test-order/'
    }

    url = process.env.VUE_APP_API_SERVER + url + orderId

    var data = {
        MarkStatus: 3,
        Details: orderDetails
    }

    console.log("confirmOrder", url, data)

    fetch(url, {
        method: 'PUT', // or 'PUT'
        body: JSON.stringify(data), // data can be `string` or {object}!
        headers: new Headers({
            'Content-Type': 'application/json',
            'Access-Token': sessionStorage.getItem("accessToken")
        })
    }).then(res => res.json())
        .catch(error => {
            console.error('confirmOrder error:', error)
            message.error("提交失败：", error.status)
            nextOrderCallback()
        })
        .then(response => {
            if (response.error == "FinishMarkTask too fast") {
                console.log("FinishMarkTask too fast！！！！")
                message.error("提交失败，请慢一点")
            } else {
                nextOrderCallback()
            }
        })
}

function confirmException(orderId, exception, nextOrderCallback) {
    var url = "/mark/"
    if (JSON.parse(sessionStorage.getItem('review'))) {
        url = '/mark-review-order/'
    }

    if (sessionStorage.getItem('role') == 28) {
        url = '/mark-test-order/'
    }
    url = process.env.VUE_APP_API_SERVER + url + orderId
    var data = {
        MarkStatus: 5,
        Details: [],
        AbnormalType: parseInt(exception)
    }

    console.log("confirmException", url, data)

    fetch(url, {
        method: 'PUT', // or 'PUT'
        body: JSON.stringify(data), // data can be `string` or {object}!
        headers: new Headers({
            'Content-Type': 'application/json',
            'Access-Token': sessionStorage.getItem("accessToken")
        })
    }).then(res => res.json())
        .catch(error => {
            console.error('confirmException error:', error)
            message.error("异常订单提交失败:", error.status)
            nextOrderCallback()
        })
        .then(response => {
            if (response.error == "FinishMarkTask too fast") {
                console.log("FinishMarkTask too fast！！！！")
                message.error("提交失败，请慢一点")
            } else {
                nextOrderCallback()
            }
        })
}

function sendException(orderId) {
    var url = "/send-exception/"
    if (sessionStorage.getItem('role') > 27) {
        return
    }

    url = process.env.VUE_APP_API_SERVER + url + orderId
    var data = {
    }

    console.log("sendException", orderId, data)

    fetch(url, {
        method: 'PUT', // or 'PUT'
        body: JSON.stringify(data), // data can be `string` or {object}!
        headers: new Headers({
            'Content-Type': 'application/json',
            'Access-Token': sessionStorage.getItem("accessToken")
        })
    }).then(res => res.json())
        .catch(error => {
            console.error('sendException error:', error)
            message.error("提交失败")
        })
        .then(response => {
            console.log("sendException result: ", response)
            if (response.error != null) {
                message.error("提交失败，请联系主管处理")
            } else {
                message.success("设备故障提交成功")
            }
        })
}

function sendRollback(orderId) {
    var url = "/send-exception/rollback/"
    if (sessionStorage.getItem('role') > 27) {
        return
    }

    url = process.env.VUE_APP_API_SERVER + url + orderId
    var data = {
    }

    console.log("sendRollback", orderId, data)

    fetch(url, {
        method: 'POST', // or 'PUT'
        body: JSON.stringify(data), // data can be `string` or {object}!
        headers: new Headers({
            'Content-Type': 'application/json',
            'Access-Token': sessionStorage.getItem("accessToken")
        })
    }).then(res => res.json())
        .catch(error => {
            console.error('sendRollback error:', error)
            message.error("撤销失败，请联系主管处理")
        })
        .then(response => {
            console.log("sendRollback result: ", response)
            if (response.error != null) {
                message.error("撤销失败，请联系主管处理")
            } else {
                message.success("上一单撤销成功")
            }

        })
}

export {
    fetchOrder,
    fetchExceptionOptions,
    confirmOrder,
    confirmException,
    sendException,
    sendRollback
}
